module.exports = __webpack_public_path__ + "img/jxsj.2dac5b02.png";